import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SubscriptionLevel } from 'src/app/auth/models/user';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-login-alert',
  templateUrl: './login-alert.component.html',
  styleUrls: ['./login-alert.component.scss'],
})
export class LoginAlertComponent implements OnInit {
  userInfo: any;
  message: string;
  isAdmin: boolean;
  isExpired: boolean;
  isShow: boolean;
  header: string;
  buttonText: string;
  constructor(public bsModalRef: BsModalRef, private router: Router) {}
  ngOnInit(): void {
    this.header = 'Billing Warning';
    this.buttonText = 'Update';
    if (this.userInfo?.data.roles[0] === 'Company Administrator') {
      this.isAdmin = true;
      if (
        this.userInfo?.data?.subscriptionLevel !== SubscriptionLevel.PREMIUM
      ) {
        this.header = 'Warning';
        this.message = this.userInfo?.data?.isMonthlyPaidCustomer
          ? 'The new and improved version of PC*Miler Web is only available to Premium subscribers at this time.  Please consider upgrading to Premium.'
          : 'The new and improved version of PC*Miler Web is only available to Premium subscribers at this time.  Please contact <a href="https://support.trimblemaps.com/" target="_blank">support@trimblemaps.com</a>  to upgrade to Premium';
        document.getElementById('content').innerHTML = this.message;
        this.buttonText = this.userInfo?.data?.isMonthlyPaidCustomer
          ? 'Update'
          : 'Ok';
      } else {
        this.isShow =
          !this.userInfo.isExpired &&
          this.isAdmin &&
          !this.userInfo?.data.hasBillingIssue;
        this.message = this.userInfo?.data.hasBillingIssue
          ? 'There was an error to the credit card on file.  Go to Account Settings and update your card information to continue.'
          : `The credit card linked to your account is set to expire on 
    ${this.userInfo?.checkExpiry.toFormat(
      'MM/dd/yyyy'
    )}.  To avoid any disruption in service, please update your card information now.`;
      }
    } else {
      if (
        this.userInfo?.data?.subscriptionLevel !== SubscriptionLevel.PREMIUM
      ) {
        this.header = 'Warning';

        this.message = this.userInfo?.data?.isMonthlyPaidCustomer
          ? 'The new and improved version of PC*Miler Web is only available to Premium subscribers at this time.  Please have your company administrator upgrade to premium.'
          : 'The new and improved version of PC*Miler Web is only available to Premium subscribers at this time.  Please have your company administrator contact <a href="https://support.trimblemaps.com/" target="_blank">support@trimblemaps.com</a> to upgrade to Premium';
        document.getElementById('content').innerHTML = this.message;
      } else {
        this.message = this.userInfo?.data.hasBillingIssue
          ? 'There was an error to the credit card on file.  Please have your company administrator go to Account Settings to update your card information.'
          : `The credit card linked to your account is set to expire on ${this.userInfo.checkExpiry.toFormat(
              'MM/dd/yyyy'
            )}.  To avoid any disruption in service, please have your company administrator to update the card information.`;
      }
    }
  }

  update(): void {
    if (
      !this.isAdmin &&
      !this.userInfo.isExpired &&
      this.userInfo?.data?.subscriptionLevel === SubscriptionLevel.PREMIUM
    ) {
      this.router.navigate(['/app']);
    } else if (
      this.userInfo?.data?.subscriptionLevel !== SubscriptionLevel.PREMIUM &&
      !this.userInfo?.data?.isMonthlyPaidCustomer
    ) {
      this.router.navigate(['/login']).then((result) => {
        window.location.href = environment.pcmilerAppUrl;
      });
    } else {
      this.router.navigate(['/accountSettings/myAccount']);
    }
    this.bsModalRef.hide();
  }
  later(): void {
    this.router.navigate(['/app']);
    this.bsModalRef.hide();
  }
}
